module.exports = {
  "$id": "professional-id-auth",
  "type": "object",
  "title": "职业身份认证",
  "properties": {
    "surname": {
      "title": "中文姓",
      "type": "string",
      "customValidate": "zhLastName"
    },
    "name": {
      "title": "中文名",
      "type": "string",
      "customValidate": "zhFirstName"
    },
    "type": {
      "title": "身份类别",
      "type": "number"
    },
    "idCard": {
      "title": "证件号码",
      "type": "string"
    },
    "organization": {
      "title": "工作单位/学校",
      "type": "string"
    },
    "mobile": {
      "title": "手机号码",
      "type": "string",
      "customValidate": "mobile"
    },
    "email": {
      "title": "E-MAIL",
      "type": "string",
      "format": "email"
    }
  },
  "required": [
    "surname",
    "name",
    "type",
    "idCard",
    "mobile",
    "organization"
  ],
  "errorMessage": {
    "surname": {
      "required": "中文姓不能为空"
    },
    "name": {
      "required": "中文名不能为空"
    },
    "type": {
      "required": "身份类别不能为空"
    },
    "idCard": {
      "required": "证件号码不能为空"
    },
    "organization": {
      "required": "请输入工作单位/学校"
    },
    "mobile": {
      "required": "手机号码不能为空"
    }
  }
}
